/**
 * Sample Data for Onboarding Previews
 * This data is completely fake and used only for demonstration
 */

import type { InsightCard, ConversationData, FocusData } from '../types';

export const sampleHomeData = {
  insightCards: [
    {
      id: 'sample-1',
      title: 'Your curiosity is growing',
      description: 'You explored 12 new topics this week',
      icon: 'sparkles',
      gradient: 'from-purple-500 to-pink-500'
    },
    {
      id: 'sample-2',
      title: 'Pattern detected',
      description: 'You learn best in the mornings',
      icon: 'sun',
      gradient: 'from-orange-400 to-yellow-400'
    },
    {
      id: 'sample-3',
      title: 'Connection found',
      description: 'Your AI interest links to productivity',
      icon: 'link',
      gradient: 'from-blue-500 to-cyan-400'
    },
    {
      id: 'sample-4',
      title: 'Momentum building',
      description: 'You\'ve been consistent for 7 days',
      icon: 'flame',
      gradient: 'from-red-500 to-orange-500'
    }
  ] as InsightCard[],
  
  recentConversation: {
    message: 'What did I learn about design this week?',
    preview: 'You explored 5 design articles, focusing on minimalism and user experience...',
    time: '2 hours ago'
  },
  
  suggestedConnection: {
    name: 'Sarah Chen',
    commonTopics: ['AI', 'Product Design', 'Productivity'],
    mutualConnections: 3
  },
  
  weeklySummary: {
    title: 'Your Week in Focus',
    items: 24,
    topTopics: ['Technology', 'Design', 'Learning']
  }
};

export const sampleAskSwirlData: ConversationData = {
  userMessage: 'Tell me about my productivity patterns',
  aiResponse: 'Based on your activity, I noticed you\'re most productive between 9-11 AM. You tend to explore technical content first thing, then shift to creative topics in the afternoon. Your engagement peaks on Tuesdays and Wednesdays.',
  insights: [
    { label: 'Peak time', value: '9-11 AM' },
    { label: 'Focus flow', value: 'Technical → Creative' },
    { label: 'Best days', value: 'Tue & Wed' },
    { label: 'Deep work', value: '2.5 hrs avg' }
  ]
};

export const sampleFocusData: FocusData = {
  title: 'Launch my side project',
  planItems: [
    { id: 1, text: 'Research competitors and market gaps', completed: false },
    { id: 2, text: 'Build landing page and MVP', completed: false },
    { id: 3, text: 'Set up social media presence', completed: false },
    { id: 4, text: 'Launch beta to first 50 users', completed: false }
  ],
  insights: [
    'Market gap identified in productivity tools',
    'Tech stack recommendations ready',
    '3 similar successful launches analyzed'
  ],
  timeline: '2-3 weeks'
};





